// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"9385b0f3","640":"d39b6df3"}[chunkId] + ".chunk.js";
};